const home =
{
    title       : 'Bienvenue sur le CMS de La Douceur Angevine.' ,
    description : 'Administrez vos données et vos contenus dans cet espace sécurisé.'
};

export default home  ;
